import React from "react";

export const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    style={{
      background: "#0f0f0f",
      borderBottom: "1px solid #1a1a1a",
      padding: "7px 20px",
      textAlign: "center",
      fontSize: 11,
      color: "#aaa",
      letterSpacing: "0.04em",
    }}
  >
    The Authority Gap — The experiment is live. theauthoritygap.co
  </div>
);
